export class MustChangePasswordException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MustChangePasswordException';
  }
}
